module.exports = __webpack_public_path__ + "static/media/session7grayscale.cefc4bc8.svg";